import { CASH_REGISTER_FORM_ANSWERS_INVALID_ERROR_CODE } from "@ac-expo/api-types";
import { isAxiosError } from "axios";

// The sale was refused because the answers no longer match the cash register form
// (a question was added, removed or left empty): the POS reopens the questions instead
// of showing a generic error.
export const isCashRegisterFormAnswersInvalidError = (
  error: unknown
): boolean =>
  isAxiosError(error) &&
  error.response?.status === 400 &&
  error.response.data?.code === CASH_REGISTER_FORM_ANSWERS_INVALID_ERROR_CODE;
